import React from 'react';

import { useClearByLearnEd, SUBMISSION_STATE } from '../Contexts/ClearByLearnEdProvider';
import ClearTicketReviewView from '../Components/ClearTicketReview';

const ClearTicketReview = () => {
  const [
    submissionState,
    { courseName, videoTitle, videoTime, images = [], screenshot, questionNo, question } = {},
    { goToFillingFormStep, goToCompletedStep },
  ] = useClearByLearnEd();
  const imageSources = images.map((image) => image?.source);
  const imageSourcesWithScreenshot = screenshot
    ? [screenshot?.source, ...imageSources]
    : imageSources;
  return (
    <ClearTicketReviewView
      images={imageSourcesWithScreenshot}
      questionNo={questionNo}
      question={question}
      initialValues={{ courseName, videoTitle, videoTime }}
      onSend={goToCompletedStep}
      onBack={() => goToFillingFormStep()}
      loading={submissionState === SUBMISSION_STATE.SUBMITTING}
    />
  );
};

export default ClearTicketReview;
